import request from '../../../../../helpers/request';

export const getHintsByServiceCompany = ({ houseId }) =>
  request.get(`Request/get_hints_by_service_company`, { houseId });

export const getHintsByRequestType = ({ houseId, typeId }) =>
  request.get(`Request/get_hints_by_request_type`, { houseId, typeId });
